import React from 'react'
import { Box, Paper } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ImageInsert as ImageInsertType } from '../../types/post'
import Image from './Image'
import RichText from '../RichText'

interface Props {
  imageInsert: ImageInsertType
}

const ImageInsert: React.FC<Props> = ({ imageInsert }) => {
  const { classes, cx } = useStyles()

  switch (imageInsert.variant) {
    case 'Framed':
      return (
        <Paper className={classes.paperFramed} component="figure">
          {imageInsert.images.length === 1 && (
            <Image
              asset={imageInsert.images[0]}
              className={classes.imgContainerFramed}
              imgClassName={classes.imgFramed}
            />
          )}
        </Paper>
      )
    case 'Full Width':
      return (
        <Paper className={classes.paperFullWidth} component="figure">
          <Image
            asset={imageInsert.images[0]}
            className={classes.imgContainerFullWidth}
            imgClassName={classes.imgFullWidth}
          />
        </Paper>
      )
    case 'Text Over Image':
      return (
        <Paper className={classes.paperFullWidth} component="figure">
          <Image
            asset={imageInsert.images[0]}
            className={classes.imgContainerFullWidth}
            imgClassName={classes.imgFullWidth}
          />
          <Box className={classes.overlaidTextBox}>
            <RichText rawBody={imageInsert.overlaidText.raw} />
          </Box>
        </Paper>
      )
    default:
      return (
        <>
          {imageInsert?.images?.length === 1 && (
            <Image
              asset={imageInsert.images[0]}
              className={cx({
                [classes.imgBorder]: imageInsert.variant === 'Border',
              })}
            />
          )}
        </>
      )
  }
}

const useStyles = makeStyles()((theme) => ({
  imgBorder: {
    border: `1px solid ${theme.colors.gray[100]}`,
  },
  imgContainerFramed: {
    boxShadow: '0 .25em .94em 0 rgba(211,211,211,0.5)',
    borderRadius: '6px',
  },
  imgFramed: {
    filter: 'contrast(1.25)',
    height: '100%',
    width: '100%',
  },
  overlaidTextBox: {
    backgroundColor: 'rgba(9, 20, 59, 0.75)',
    borderRadius: theme.shape.borderRadius,
    bottom: '3rem',
    color: theme.palette.background.default,
    left: '3rem',
    maxHeight: 'calc(100% - 6rem)',
    maxWidth: 'calc(100% - 6rem)',
    padding: '1.5rem',
    position: 'absolute',
    width: '24.5rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  paperFramed: {
    marginBlockStart: '2em',
    marginBlockEnd: '0',
    marginInlineStart: '0',
    marginInlineEnd: '0',
    padding: '3.51em 4.47em 3.55em',
    [theme.breakpoints.down('md')]: {
      padding: '0',
    },
  },
  paperFullWidth: {
    backgroundColor: 'transparent',
    marginBlockStart: '0',
    marginBlockEnd: '0',
    marginInlineStart: '0',
    marginInlineEnd: '0',
    padding: '0',
    position: 'relative',
  },
  imgContainerFullWidth: {
    boxShadow: '0',
    borderRadius: '0px',
    maxWidth: '100% !important',
  },
  imgFullWidth: {
    height: '100%',
    width: '100%',
  },
}))

export default ImageInsert
